module.exports = __webpack_public_path__ + "img/5.aa4ea8c2.jpg";